// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__0TYol","prefix":"index_prefix__9dwGt","hasPrefix":"index_hasPrefix__tX5Vj"};